module.exports = __webpack_public_path__ + "static/scale-model-of-baltimore-maryland-76ba2b5bec54e7df258654198608c536.png";